import type { Conversation, MetaConversation } from 'lib-shared-legacy-types';
import { ComponentProps } from 'react';
import { connect } from 'react-redux';

import { useConversationDraft } from 'utils/conversationDrafts';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { templatesActions } from '../../settings/actions/templates';
import { actions } from '../actions/conversation';
import { actions as conversationsActions } from '../actions/conversations';
import NoteForm from '../components/NoteForm';

const mapStateToProps = (state) => {
  const metaConversation: MetaConversation =
    state.conversation.metaConversation;
  return {
    csid: metaConversation.conversation.id,
    agentId: state.settings.profile.profile.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    conversationAddWrapup: bindActionToPromise(
      dispatch,
      actions.conversationAddWrapup,
    ),
    templatesRender: bindActionToPromise(
      dispatch,
      templatesActions.templatesRender,
    ),
    conversationMarkSeen: (payload: { csid: Conversation['id'] }) =>
      dispatch(conversationsActions.conversationsMarkSeen(payload)),
  };
};

type NoteFormHookAdapterProps = Omit<
  ComponentProps<typeof NoteForm>,
  'draft' | 'saveDraft' | 'clearDraft' | 'flushDraft'
>;

const NoteFormHookAdapter = (props: NoteFormHookAdapterProps): JSX.Element => {
  const { draft, saveDraft, clearDraft, flushDraft } = useConversationDraft(
    props.csid,
  );

  return (
    <NoteForm
      {...props}
      draft={draft}
      saveDraft={saveDraft}
      clearDraft={clearDraft}
      flushDraft={flushDraft}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NoteFormHookAdapter);
